import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import IconFairness from '../iconFairness';
import GameLogo from '../gameLogo';
import { TAB_INDEX } from '../../core/constants/gameConstants';
import BetSlip from '../betSlip';
import AllBets from '../allBets';
import TabRow from '../../games/keno/tabRow';
import { kenoBetStore } from '../../store/kenoBetStore';

const LiveTickets = observer(() => {
  const { liveBetActiveTabIndex, setLiveBetActiveTabIndex } = kenoBetStore;

  const tabsInfo = useMemo(() => {
    return {
      [TAB_INDEX.BetSlip]: BetSlip,
      [TAB_INDEX.AllBets]: AllBets,
    };
  }, []);

  const ActiveTabInfo = useMemo(() => {
    return tabsInfo[liveBetActiveTabIndex];
  }, [liveBetActiveTabIndex, tabsInfo]);

  return (
    <div className='keno-betslip'>
      <div className='keno-betslip-wrapper'>
        {!isMobile() && (
          <>
            <IconFairness />
            <GameLogo />
          </>
        )}
        <div className='betslip-tab-info-row'>
          <div className='betslip-tab-row-wrapper'>
            <TabRow
              activeTabIndex={liveBetActiveTabIndex}
              setActiveTabIndex={setLiveBetActiveTabIndex}
            />
          </div>
        </div>
        <div className='bet-information-wrapper'>
          <div className='bet-information-content'>
            <ActiveTabInfo />
          </div>
        </div>
      </div>
    </div>
  );
});

export default LiveTickets;
